import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import {
    Container,
    Row,
    Col,
    Card,
    CardImg
} from "reactstrap";
import Link from 'next/link';
import styles from './styles.module.scss';
import Pagination from '../../components/Pagination';

export default function AllBlogs({
    global,
    pathPrefix,
    customClass,
    all_blogs,
    buttonTitle,
    heading,
    enableHeading = true,
    isAllBlogsPage = false,
    enablePagination = true,
    all_paginations,
    all_currentPage,
    pageLink,
    pagePrefix

}) {

    return (
        all_blogs?.length >= 1 && (<section className={`${styles.root} ${customClass}`}>
            <Container>
                <div className={`content-wrapper ${isAllBlogsPage ? "isBlogPage" : "rounded-4 border p-lg-5 p-4"}`}>
                    {enableHeading ?
                        <h2 className="text-center mb-5">
                            <SourceFlowText global={global} path={`${pathPrefix}.heading`}>{heading}</SourceFlowText>
                        </h2> : ""}
                    <Row>
                        {isAllBlogsPage ?
                            <>
                                {all_blogs?.map((post, index) => (
                                    (index >= 3 ?
                                        <>
                                            <Col md={12} key={index} className="mb-0 mb-md-4 mb-lg-0">
                                                <Link href={`/${pagePrefix}/${post?.url_slug}`}>
                                                    <a className="text-decoration-none d-block h-100">
                                                        <Card className="p-2 border flex-wrap justify-content-between rounded-3 overflow-hidden d-flex mb-4">
                                                            <div className="d-flex flex-nowrap align-items-start align-items-md-center">
                                                                <div className="img-wrapper rounded-3 overflow-hidden">
                                                                    <SourceFlowImage
                                                                        src={post?.image ? post.image : "/site-assets/images/image-placeholder.webp"}
                                                                        size="600x600"
                                                                        alt={post?.title}
                                                                        className="card-img"
                                                                        width="100%"
                                                                        height="100%"
                                                                    />
                                                                </div>
                                                                <h5 className="post-title m-0  ps-3 ps-md-5 pe-2 pe-md-5">{post?.title}</h5>
                                                            </div>
                                                            <div className="mt-4 text-end">
                                                                <span className="primaryBtn">
                                                                    <SourceFlowText global={global} path={`${pathPrefix}.buttonTitle`}>
                                                                        {buttonTitle}
                                                                    </SourceFlowText>
                                                                </span>
                                                            </div>
                                                        </Card>
                                                    </a>
                                                </Link>
                                            </Col>
                                        </> : "")
                                ))}
                                {enablePagination ?
                                    all_paginations.length > 1 && (
                                        < Pagination pagination={all_paginations} currentPage={all_currentPage} pageLink={pageLink} />
                                    )

                                    : null}
                            </> : <>
                                {all_blogs?.map((post, index) => (
                                    <Col xs={12} lg={4} key={index} className="mb-4 mb-lg-0">
                                        <Link href={`/${pagePrefix}/${post?.url_slug}`}>
                                            <a className="text-decoration-none d-block h-100">
                                                <Card className="p-2 border justify-content-between rounded-3 overflow-hidden h-100">
                                                    <div>
                                                        <div className="img-wrapper rounded-3 overflow-hidden">
                                                            <SourceFlowImage
                                                                src={post?.image ? post.image : "/site-assets/images/image-placeholder.webp"}
                                                                size="1000x400"
                                                                alt={post?.title}
                                                                className="card-img"
                                                                width="100%"
                                                                height="100%"
                                                            />
                                                        </div>
                                                        <h5 className="post-title mt-4 ps-3 pe-3">{post?.title}</h5>
                                                    </div>
                                                    <div className="mt-4 text-end">
                                                        <span className="primaryBtn">
                                                            <SourceFlowText global={global} path={`${pathPrefix}.buttonTitle`}>
                                                                {buttonTitle}
                                                            </SourceFlowText>
                                                        </span>
                                                    </div>
                                                </Card>
                                            </a>
                                        </Link>
                                    </Col>
                                ))}
                            </>}
                    </Row>
                </div>
            </Container>
        </section>
        )
    )
}